import React from 'react';
import styles from './LoginsManager.module.scss';
import {$t} from "../../helpers/translator";
import ConfirmationBox from "../miscellaneous/ConfirmationBox/ConfirmationBox";
import {logout} from "../../store/auth-slice";
import {connect} from "react-redux";
import {clearData} from "../../store/data-slice";


class LoginsManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            logoutEverywhereModal: false,
            loader: false,
        };
    }

    async componentDidMount() {

    }

    renderLogoutEverywhereModalContent() {
        return (
            <div className={styles.centerText}>
                <div className={styles.b}>{$t('global.account.logoutAllText1')}</div>
                <div>{$t('global.account.logoutAllText2')}</div>
            </div>
        )
    }

    closeModals() {
        this.setState({logoutEverywhereModal: false})
    }

    async logoutEverywhereConfirmHandler() {
        this.setState({loader: true}, async () => {
            try {
                await this.props.dispatch(clearData());
                await this.props.dispatch(logout(true));
            } catch (e) {
                console.error('err logout all', e)
            } finally {
                this.setState({loader: false, logoutEverywhereModal: false})
            }
        })
    }

    async logoutConfirmHandler() {
        try {
            await this.props.dispatch(clearData());
            await this.props.dispatch(logout(false));
        } catch (e) {
            console.error('err logout ', e)
        } finally {
            let env = process.env.REACT_APP_ENV
            if (env !== 'local') {
                window.location.replace(process.env.REACT_APP_WEBSITE_OLD + '?logout=true');
            }
        }
    }

    render() {
        return (
            <div className={'alma-box'}>
                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.account.logoutFromAccount')}</h3></span>
                </div>

                <div className={'alma-box-content'}>
                    <div className={styles.buttonsRow}>
                        <div className={styles.buttonContainer}>
                            <div className={'alma-button'} onClick={async () => await this.logoutConfirmHandler()}>
                                {$t('global.account.logout')}
                            </div>
                        </div>
                        <div className={styles.buttonContainer}>
                            <div className={'alma-button'} onClick={() => this.setState({logoutEverywhereModal: true})}>
                                {$t('global.account.logoutAll')}
                            </div>
                        </div>

                    </div>
                </div>

                <ConfirmationBox
                    visible={this.state.logoutEverywhereModal}
                    content={this.renderLogoutEverywhereModalContent()}
                    confirmButtonShow={true}
                    confirmButtonText={$t('global.general.confirm')}
                    confirmButtonAction={() => this.logoutEverywhereConfirmHandler()}
                    cancelButtonShow={true}
                    cancelButtonText={$t('global.general.cancel')}
                    cancelButtonAction={null}
                    onClose={() => this.closeModals()}
                    loading={this.state.loader}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(LoginsManager);

/**
 * this is a class component imported from old project
 * is uses 'dispatch', which is only available in the new project, and is being used only in functional components.
 *
 * for it to work in a class component, we export the component as written above, and not as usual:
 * export default LoginsManager;    //removed
 *
 * also, calling dispatch will be with the following syntax:
 * dispatch();  //removed
 * this.props.dispatch();
 *
 */
